export enum FuelType {
  BENZIN = 1,
  DIESEL = 2,
  BENZINAUTOGAS = 3,
  LPG = 4,
  BENZINERDGAS = 5,
  BENZINALKOHOL = 6,
  BENZINELEKTRO = 7,
  DIESELELEKTRO = 8,
  ELEKTRO = 9,
  FLEXFUEL = 10,
  CNG = 11,
  WASSERSTOFF = 12,
  GEMISCH = 13,
  BENZINETHANOLELEKTRO = 14,
  BENZINMETHANOL = 15,
  ETHANOL = 10271,
}
